import strings from '../../strings/strings.json'

export default class VolCalculator {

    static calculate(count) {
        //Numbers are of the byte type
        if (count < 1024)
            return count + ' ' + strings.general_byte
        if (count >= 1024 && count < 1048576)
            return this.divider(count, strings.general_kiloByte, 1024)
        else if (count >= 1048576 && count < 1073741824)
            return this.divider(count, strings.general_megaByte, 1048576)
        else if (count >= 1073741824 && count < 1099511627776)
            return this.divider(count, strings.general_gigaByte, 1073741824)
    }


    static divider(cnt, str, num) {

        return Math.floor(cnt / num) + ' ' + str
    }
}
